<template>
  <div class="form-dd__container" ref="formDd">
    <div
      class="form-dd__row-container"
      :class="{ 'form-dd__row-container__modal': thisIsModal }"
      @click="toggleDD"
    >
      <div class="form-dd__text">{{ textInput }}</div>
      <img
        class="form-dd__arrow"
        :class="{ 'deg-90__form-arrow': isOpen }"
        :src="formArrow"
        alt=""
      />
    </div>
    <div
      class="form-dd__table-container"
      :class="{ 'form-dd__table-container__modal': thisIsModal }"
      v-show="isOpen"
    >
      <div
        class="form-dd__table-row"
        v-for="row of rowArray"
        :key="row.id"
        :class="{ 'acive-row': row.isActive }"
        @click="clickOnRow(row.id, row.text)"
      >
        {{ row.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["submitted", "thisIsModal"],
  data() {
    return {
      formArrow: require("@/assets/images/iconoir_arrow-br.svg"),

      textInput: "Какая услуга вас интересует ?*",
      isOpen: false,

      rowArray: [
        {
          id: 1,
          isActive: false,
          text: "СММ",
        },
        {
          id: 2,
          isActive: false,
          text: "WEB Разработка",
        },
        {
          id: 3,
          isActive: false,
          text: "Дизайн / Брендинг",
        },
        {
          id: 4,
          isActive: false,
          text: "Видео Продакшн / Фотосъёмка",
        },

        {
          id: 5,
          isActive: false,
          text: "Моушн Дизайн",
        },
        {
          id: 6,
          isActive: false,
          text: "Пиар",
        },
      ],
    };
  },

  watch: {
    submitted() {
      this.textInput = "Какая услуга вас интересует ?*";
      this.rowArray.forEach((item) => {
        item.isActive = false;
      });
    },
  },
  mounted() {
    window.addEventListener("click", this.listenClick);
  },
  beforeUnmount() {
    window.removeEventListener("click", this.listenClick);
  },
  methods: {
    toggleDD() {
      this.isOpen = !this.isOpen;
    },
    listenClick(event) {
      if (!this.$refs.formDd.contains(event.target)) {
        this.isOpen = false;
      }
    },
    clickOnRow(id, text) {
      const item = this.rowArray.find((item) => item.id === id);
      const localStorage = item.isActive;

      this.rowArray.forEach((item) => {
        item.isActive = false;
      });
      item.isActive = !localStorage;

      this.textInput = text;

      this.$emit("selectRow", text);

      this.toggleDD();
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/grid/grid";

.form-dd__container {
  position: relative;
}
.form-dd__row-container {
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  @include adaptivHeightlg(49, 35);

  @include adaptivMarginlg(0, 0, 0, 12, 0, 0, 0, 6);
  @include adaptivPaddinglg(25, 25, 0, 0, 10, 10, 0, 0);

  font-family: "Helvetica-normal";
  font-style: normal;
  font-weight: 300;
  color: #8e8e8e;
  @include adaptiv-fontlg(15, 12);
  @include adaptiv-lineHeightlg(18, 15);

  border: none;
  border-radius: 0px;

  background: #eeeded;

  cursor: pointer;

  @media (min-width: 1921px) {
    height: 45px;

    font-size: 17px;
  }
  @media (max-width: 768px) {
    @include adaptivHeightmd(96, 30);
    @include adaptivMarginmd(0, 0, 27, 27, 0, 0, 12, 12);
    @include adaptivPaddingmd(15, 15, 0, 0, 10, 10, 0, 0);

    @include adaptiv-lineHeightmd(31, 12);
    @include adaptiv-fontmd(31, 12);
    text-align: center;
  }
}
.form-dd__text {
}
.form-dd__arrow {
  transition: all 0.2s ease-in-out 0s;
}
.deg-90__form-arrow {
  transform: rotate(-90deg);
}
.form-dd__table-container {
  position: absolute;
  top: 110%;
  left: 0;

  display: flex;
  flex-direction: column;
  gap: 1px;

  width: 100%;
  height: 179px;

  background-color: #292929;
  border-radius: 0 0 8px 8px;

  overflow-x: hidden;
  overflow-y: auto;

  z-index: 2;

  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 40px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #fff;
    width: 3px;

    border-radius: 40px;
  }
}
.form-dd__table-row {
  display: flex;

  width: 100%;

  padding: 12px 16px;

  color: #fff;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  background: #462e70;

  cursor: pointer;

  transition: all 0.2s linear 0s;

  &:hover {
    background: #322150;
  }
}
.acive-row {
  background: #322150;
}

// Для модальной формы ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
.form-dd__row-container__modal {
  width: 100%;
  @include adaptivHeightlg(49, 32);
  display: flex;
  font-family: "Helvetica-thin";
  font-style: normal;
  font-weight: 300;
  color: #8e8e8e;
  @include adaptiv-fontlg(15, 8);
  @include adaptiv-lineHeightlg(18, 10);
  @include adaptivMarginlg(0, 0, 0, 12, 0, 0, 0, 6);
  @include adaptivPaddinglg(25, 25, 0, 0, 10, 10, 0, 0);
  border: none;
  border-radius: 0px;
  background: #eeeded;
  @media (max-width: 768px) {
    @include adaptivMarginmd(0, 0, 0, 8, 0, 0, 0, 6);
    @include adaptiv-fontmd(25, 15);
    @include adaptiv-lineHeightmd(25, 15);
    @include adaptivHeightmd(80, 40);
    @include adaptivPaddingmd(15, 15, 0, 0, 10, 10, 0, 0);
  }
}

.form-dd__table-container__modal {
  background-color: #fff;

  &::-webkit-scrollbar {
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #a287d1;
  }
}
</style>
